
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.414 12.165l-6.562 6.562c-.586.586-1.602.176-1.602-.664v-3.75H7.937A.935.935 0 017 13.376v-3.75c0-.52.418-.938.938-.938h5.312v-3.75c0-.836 1.012-1.25 1.602-.664l6.562 6.563a.946.946 0 010 1.328zM9.5 18.532V16.97a.47.47 0 00-.469-.47H5.75c-.691 0-1.25-.558-1.25-1.25v-7.5c0-.69.559-1.25 1.25-1.25h3.281a.47.47 0 00.469-.468V4.47A.47.47 0 009.031 4H5.75C3.68 4 2 5.68 2 7.75v7.5C2 17.322 3.68 19 5.75 19h3.281a.47.47 0 00.469-.468z","fill":"#999"}})])
          )
        }
      }
    